// Module
var code = `<div ng-if="\$ctrl.preview && \$ctrl.preview.targets.length > 0">
  <h2 class="section-header">{{\$ctrl.conditionText}}, Automatic debit agreement will be auto-configured:</h2>
  <div class="alert">This auto-configuration preview is based on the current status of the source account and target products</div>

  <div ng-if="\$ctrl.preview.accountProductNumber">
    <h3>Source account: {{\$ctrl.preview.accountProductName}} ({{\$ctrl.preview.accountProductNumber}})</h3>
  </div>

  <table class="table">
    <thead>
    <th>Order</th>
    <th>Product name</th>
    <th>Product number</th>
    </thead>
    <tbody class="tbody">
    <tr ng-repeat="target in \$ctrl.preview.targets">
      <td>{{target.orderNo}}</td>
      <td>{{target.productName}}</td>
      <td>{{target.productNumber}}</td>
    </tr>
    </tbody>
  </table>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/ada/ada-auto-configuration-preview.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;